import { CARD_TYPE, CARD_TYPE_LABEL } from '../constants/cardType';
import { DVA_CARD_TYPE } from '../constants/dvaCardType';

const VISIBLE_DIGIT_COUNT = 4;
const NOT_WITH_ME_STATUS = 'Medicare card details to be provided';
const MEDICARE_NUMBER_LABEL = 'Medicare Card Number';
const MEDICARE_STATUS_LABEL = 'Medicare';

export const maskMedicareCardNumber = (cardNumber) => {
  const digits = String(cardNumber ?? '').replace(/\D/g, '');

  if (!digits) return '';

  const maskedLength = Math.max(digits.length - VISIBLE_DIGIT_COUNT, 0);

  return `${'*'.repeat(maskedLength)} ${digits.slice(
    -VISIBLE_DIGIT_COUNT
  )}`.trim();
};

const formatDvaStatus = (medicare) => {
  const matchedCardType = DVA_CARD_TYPE.find(
    ({ value }) => value === medicare?.dvaCardType
  );
  const statusParts = [
    matchedCardType ? `DVA ${matchedCardType.label} Card` : 'DVA Card',
    medicare?.dvaNumber,
  ].filter(Boolean);

  return statusParts.join(' \u00b7 ');
};

export const formatMedicareStatus = (medicare) => {
  const cardType = medicare?.cardType || CARD_TYPE.MEDICARE;

  if (cardType === CARD_TYPE.MEDICARE) {
    const maskedCardNumber = maskMedicareCardNumber(
      medicare?.medicareCardNumber
    );

    if (!maskedCardNumber) return null;

    const cardIRN = medicare?.medicareCardIRN;

    return {
      label: MEDICARE_NUMBER_LABEL,
      value: cardIRN
        ? `${maskedCardNumber} \u00b7 IRN ${cardIRN}`
        : maskedCardNumber,
    };
  }

  if (cardType === CARD_TYPE.DVA) {
    return {
      label: MEDICARE_STATUS_LABEL,
      value: formatDvaStatus(medicare),
    };
  }

  if (cardType === CARD_TYPE.NOT_WITH_ME) {
    return {
      label: MEDICARE_STATUS_LABEL,
      value: NOT_WITH_ME_STATUS,
    };
  }

  return {
    label: MEDICARE_STATUS_LABEL,
    value: CARD_TYPE_LABEL[CARD_TYPE.NONE],
  };
};
